<template>
  <div class="login-form u-center u-grey-light">
    <div class="login-form__bg u-middle u-row u-bg-grey u-w8of12 u-w10of12--md u-w11of12--sm">
      <div class="u-w6of12 u-w12of12--sm u-pad-t-md--sm">
        <div class="u-row u-middle u-center">
          <img src="/images/logo--full.png" class="u-w8of12">
        </div>
      </div>
      <div class="u-w6of12 u-w12of12--sm">
        <div class="u-row u-middle u-pad-lg u-pad-md--sm">
          <form v-if="!isSend" class="u-full-width">
            <div class="t-h3 u-marg-b-md">
              {{ isNew ? $t('login.title') :  $t('login.titleIn') }}
            </div>
            <div class="u-marg-b-md">
              <app-button :blue="true" @click="onMS" :icon="true">
                <div class="ms__text t-text--small">
                  {{ isNew ? $t('login.microsoft') :  $t('login.microsoftIn') }}
                </div>
                <img src="/images/logo--small.png" class="ms__picto">
              </app-button>
            </div>
            <div class="login-form__net u-marg-b-sm">
              <div class="u-inline-block u-bg-grey u-pad-x-sm u-relative">
                or
              </div>
            </div>
            <div class="u-left">
              <div v-if="error.length" class="t-text t-text--big u-center u-red">
                <div v-for="(err, index) in error" :class="index !== 0 ? 'u-marg-t-xs' : ''">
                  {{ err }}
                </div>
              </div>
              <div>
                <label for="firstName">{{$t('login.email')}}</label>
                <input
                  v-model="mail"
                  type="email"
                  id="email"
                  class="t-input u-full-width"
                />
              </div>
              <div>
                <label for="lastName">{{$t('login.password')}}</label>
                <input
                  v-model="password"
                  type="password"
                  id="password"
                  class="t-input u-full-width"
                />
              </div>
              <div v-if="isNew">
                <label for="company">{{$t('login.passwordConfirm')}}</label>
                <input
                  v-model="confirm"
                  type="password"
                  id="passwordConfirm"
                  class="t-input u-full-width"
                />
              </div>
              <div class="u-marg-t-md u-center">
                <router-link :to="$local('reset')" class="t-link t-text t-text--small">
                  {{ $t('login.forgot') }}
                </router-link>
              </div>
              <div v-show="!$device.isTablet" class="u-marg-t-md">
                <app-button @click="onValidate">
                  {{ $t('login.goToSbs') }}
                </app-button>
              </div>
            </div>
          </form>
          <form v-else class="u-full-width">
            <img src="/images/mail-send.png" class="u-w5of8 u-pad-r-md u-pad-t-md u-pad-b-md">
            <p class="u-grey-light u-marg-b-xs">{{ $t('login.verify') }}</p>
            <p class="u-white u-pad-t-xs">{{mail}}</p>
            <app-button v-show="!$device.isTablet" @click="$router.push($local('signin'))" class="u-marg-t-md u-marg-b-md">
                {{ $t('login.backToLog') }}
            </app-button>
          </form>
        </div>
      </div>
    </div>
    <div v-show="$device.isTablet" class="u-full-width u-center u-marg-t-md">
      <template v-if="isSend == false">
        <app-button v-if="isNew" :has-gradient-border="true" class="u-inline-block u-marg-r-sm" @click="$router.push($local('signin'))">
          {{ $t('login.signIn') }}
        </app-button>
        <app-button v-if="!isNew" :has-gradient-border="true" class="u-inline-block u-marg-r-sm" @click="$router.push($local('create'))">
          {{ $t('login.signUp') }}
        </app-button>
        <app-button class="u-inline-block" @click="onValidate">
          {{ $t('login.goToSbs') }}
        </app-button>
      </template>
    </div>
  </div>
</template>

<script>
import { auth } from '@/utils/Auth'
import { log } from 'three'

const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export default {
  props: {
    isNew: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      mail: '',
      password: '',
      confirm: '',
      error: [],
      isSend: false
    }
  },

  // mounted () {
  //   auth.crossOrigin()
  // },

  methods: {
    onMS () {
      this.$ga.send('SSO', 'Callback', 'OK')
      auth.loginMS()
    },
    onValidate () {
      this.error.splice(0, this.error.length)

      if (this.isNew) {
        if (this.password.length < 8) {
          this.error.push(this.$t('login.error.length'))
        }
        if (this.password !== this.confirm) {
          this.error.push(this.$t('login.error.confirm'))
        }
        if (!regex.test(this.mail)) {
          this.error.push(this.$t('login.error.mail'))
        }

        if (this.error.length) {
          return
        }

        auth.signUpMail(this.mail, this.password).then(()=>{
          this.$ga.send('Login without SSO', 'Callback', 'OK')
          this.isSend = true
        }).catch(err => {
          this.$ga.send('Login without SSO', 'Callback', 'KO')
        })
      }
      else {
        auth.loginMail(this.mail, this.password).catch(err => {
          this.error.push(this.$t('login.error.default'))
          // this.error.push(err)
        })
      }
    },
    onReset () {
      this.$router.push(this.$local('reset'))
      this.$ga.send('Menu', 'Click', 'Forgotten password')
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/variables'

.login-form
  &__net
    position relative

    &:before
      content ''
      position absolute
      top 50%
      left 0
      width 100%
      height 1px
      background-color $colors.grey-light
      
  .login-form__bg
    border-radius 25px
    margin auto

.ms
  &__text
    width calc( 100% - 2em )
  &__picto
    width 2em
</style>